<template>
  <div class="list-item flex flex-column justify-between entity-primary">
    <div class="flex flex-row items-top justify-between f6 entity-secondary ttu lh-title tracked">
      <div class="flex flex-column">
        <div class="flex flex-row items-center">
          <span class="db f6">
            Договор
          </span>
          <span v-if="out" class="db f6 ttl pl2" id="outgoing_contract">
            исходящий
          </span>
          <span v-else class="db f6 ttl pl2" id="incoming_contract">
            входящий
          </span>
        </div>
      </div>
      <div class="flex flex-row">
        <span class="text-secondary mr1">№</span>
        <div v-if="contract.number" class="text-primary" id="contract_number">{{ contract.number }}</div>
        <div v-else class="text-secondary ttl" id="contract_number">нет</div>
      </div>
    </div>

    <div class="mt1 flex flex-row items-center justify-start f6 ttl fw6" id="contract_status">
      {{ contract.status_name }}
    </div>

    <router-link :to="{ name: 'contract_card', params: { id: contract.id } }" class="mt3 link lh-copy entity-primary">
      <div>
        <div>
          <span v-if="contract.title" class="text-line-3 f5 underline" id="contract_id">
            {{ contract.title || 'Договор ID ' + contract.id}}
          </span>
          <span v-else class="text-secondary f5 underline">без наименования</span>
        </div>
      </div>
    </router-link>

    <div v-if="out" class="mt3 f6 flex flex-column">
      <span class="db entity-secondary" id="contract_counterparty_company_name"><font-awesome-icon :icon="['far', 'building']" class="mr2"/>
        {{ contract.counteragent_company_name }}
      </span>
      <span class="db entity-secondary f7">контрагент</span>
    </div>
    <div v-else class="mt3 f6 flex flex-column">
      <span class="db entity-secondary" id="contract_organizer_company_name"><font-awesome-icon :icon="['far', 'building']" class="mr2"/>
        {{ contract.company_name }}
      </span>
      <span class="db entity-secondary f7">организатор</span>
    </div>

    <div class="mt3 entity-secondary f7">
      <div class="flex flex-row justify-between ttl lh-copy tracked">
        <div v-if="contract.start_at" class="flex flex-column f7">
          <span class="db entity-secondary" id="start_date_of_the_contract" title="дата начала действия договора">
            <font-awesome-icon icon="hourglass-start" class="mr2"/>
            <span class="">{{ format(contract.start_at) }}</span>
          </span>
          <span v-if="contract.close_at" class="db entity-secondary" id="expiration_date_of_the_contract" title="дата окончания действия договора">
            <font-awesome-icon icon="hourglass-end" class="mr2"/>
            <span class="">{{ format(contract.close_at) }}</span>
          </span>
        </div>
        <div class="flex flex-column">
          <div class="flex">
            <div v-if="contract.products_count" title="Кол-во товаров" class="mr2" id="contract_products_count">
              <span class="mr1"><font-awesome-icon icon="box-open" /></span><span>{{ contract.products_count }}</span>
            </div>
            <div v-if="contract.orders_count" title="Кол-во заказов" class="mr2" id="contract_orders_count">
              <span class="mr1"><font-awesome-icon icon="truck" /></span><span>{{ contract.orders_count }}</span>
            </div>
            <div v-if="contract.total_sum" title="Cумма договора" class="mr2" id="contract_total_sum">
              <span class="mr1"><font-awesome-icon icon="ruble-sign" /></span><span>{{ contract.total_sum }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
const moment = require('moment')

export default {
  props: {
    contract: { type: Object },
    direction: { type: String }
  },
  computed: {
    hightPriority () {
      return this.app.priority_id === 1
    },
    out () {
      return this.contract.direction === 'OUT'
    }
  },
  methods: {
    format (dt) {
      return moment(dt).format('DD.MM.YYYY')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
